import { useContext, useEffect, useState } from 'react';
import { InfoContext } from "./ApiCenter/AM_BackGroundOP"

const Protected = ({ 
    returnNull=false, 
    admin=[], 
    internal=[], 
    externalSite=[],
    readOnly=[], 
    permissions=[], 
    denyPermissions=[], 
    extraCondition=true, 
    skipPermissions=false, 
    returnIfNoData=false,
    children, 
    refreshKey=null, 
    refreshFn=null, 
}) => {
    
    const ctx = useContext(InfoContext);
    const [, setRefresh] = useState(false);
    
    useEffect(() => { 
        if(!ctx?.userData?.current) return;

        const refreshArray = [...new Set([...permissions, ...denyPermissions])];
        if(admin.length > 0) refreshArray.push('admin');
        if(internal.length > 0) refreshArray.push('internal');
        if(readOnly.length > 0) refreshArray.push('readOnly');
        if(refreshKey) {
            refreshArray.push(refreshKey);
        }
        
        const refreshUI = () => setRefresh(p => !p);
        refreshArray.forEach(p => {
            if(!ctx.compRefs.current?.hasOwnProperty(p)) ctx.compRefs.current[p] = new Set();
            ctx.compRefs.current[p].add(refreshUI); 
        })

        if(refreshFn) refreshFn?.();

        return () => {
            refreshArray.forEach(p => {
                ctx.compRefs.current?.[p]?.delete(refreshUI);
            })   
        }
    }, [ctx, admin, internal, permissions, denyPermissions, readOnly, refreshKey, refreshFn])
    
    const notAllowedElement = returnNull ? null : <main className="main" id="main">You are not allowed to access this page.</main>;
    
    if(returnIfNoData && !ctx?.userData?.current) return children;
    if(!ctx?.userData?.current) return notAllowedElement;
    if(denyPermissions.length > 0 && denyPermissions.some(p => ctx.userData.current?.permissions?.[p])) return notAllowedElement;
    if(skipPermissions) return children;
    if(typeof extraCondition === 'function') extraCondition = extraCondition();
    
    if (
        (extraCondition) &&
        (admin.length > 0 ? admin.includes(ctx.userData.current.admin) : true) &&
        (internal.length > 0 ? internal.includes(ctx.userData.current.internal) : true) &&
        (externalSite.length > 0 ? externalSite.includes(ctx.userData.current.ext_site) : true) &&
        (readOnly.length > 0 ? readOnly.includes(ctx.userData.current.readOnly) : true) &&
        (permissions.length > 0 ? permissions.some(p => ctx.userData.current.permissions?.[p]) : true)
    ) return children;
    
    return notAllowedElement;
};

export default Protected;
